import { IAuthenticateGameConfig } from '@GFTypes/GameStoreTypes/AuthenticateGameConfig';

export const AUTHENTICATE_GAME_CONFIG_DEFAULTS: IAuthenticateGameConfig = {
    finalDivider: 0,
    gamble: {
        halfMinValue: {
            raw: 0,
            normalized: 0,
            formatted: ''
        },
        halfTimes: 0,
        maxTries: 0,
        maxWin: {
            raw: 0,
            normalized: 0,
            formatted: ''
        },
        minWin: {
            raw: 0,
            normalized: 0,
            formatted: ''
        },
        options: []
    },
    payLines: [],
    powerLines: false,
    rtp: 0,
    symbols: [],
    spinningReels: []
};
